const APP_PATH = '';


export const routePath = {
    home     : `${APP_PATH}/`,
    categories :`${APP_PATH}/categories`,
    invalid   :`${APP_PATH}/*`
}